import { Box, Button, CircularProgress } from "@mui/material";

import { Colors, GreyPallet } from "../../config/styles";

import theme from "../../config/Theme";
import MainText from "../MainText";

type ComponetProps = {
  text?: string;
  loading?: boolean;
  dashed?: boolean;
  icon?: JSX.Element;
  onClick?: () => void;
  fullWidth?: boolean;
  color?:
    | "black"
    | "default"
    | "white"
    | "grey"
    | "danger"
    | "error"
    | "info"
    | "success"
    | "warning";
  small?: boolean;
};

export default function MainBorderButton({
  text,
  loading,
  icon,
  dashed,
  onClick,
  fullWidth = true,
  color = "black",
  small,
  ...props
}: ComponetProps) {
  const customBorderColor =
    color === "error" || color === "danger"
      ? Colors.Danger
      : color === "grey"
      ? GreyPallet.Light
      : color === "info"
      ? theme.palette.info.main
      : color === "success"
      ? theme.palette.success.main
      : color === "warning"
      ? theme.palette.warning.main
      : color === "default"
      ? GreyPallet.Regular
      : "#000";

  const customTextColor = color === "grey" ? GreyPallet.LightGhost : "#fff";

  return (
    <Button
      {...props}
      onClick={onClick}
      color="secondary"
      fullWidth={fullWidth}
      style={{
        height: small ? 40 : 60,
        borderRadius: "15px",
        textTransform: "none",
        backgroundColor: "transparent",
        color: customBorderColor,
        border: `3px ${dashed ? "dashed" : "solid"} ${customBorderColor}`,
      }}
    >
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <MainText color={"inherit"}>{text}</MainText>

        {loading ? (
          <Box
            style={{ marginLeft: text ? 12 : 0, width: "26px" }}
            display={"flex"}
            alignItems={"center"}
          >
            <CircularProgress size={"20px"} color="inherit" />
          </Box>
        ) : icon ? (
          <Box
            style={{ marginLeft: text ? 12 : 0, width: "26px" }}
            display={"flex"}
            alignItems={"center"}
            sx={{ "& .MuiSvgIcon-root": { color: "inherit" } }}
          >
            {icon}
          </Box>
        ) : null}
      </Box>
    </Button>
  );
}
